var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showDisrupter()
    ? _c("div", { staticClass: "index-disrupter" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "index-disrupter-inner" }, [
            _c("h5", [
              _vm._v(
                "\n         Buchen Sie JETZT Ihren Weihnachts-/Silvesterurlaub im OstseeResort Olpenitz!\n"
              )
            ]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c("h5", [_vm._v("\n          inklusive Winter-Vorteil:\n")]),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c("p", { staticClass: "button-text" }, [
              _c(
                "a",
                {
                  staticClass: "btn search-btn closebtn",
                  on: {
                    click: function($event) {
                      return _vm.hideDistrupter()
                    }
                  }
                },
                [_vm._v("SCHLIEßEN")]
              )
            ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", [_vm._v("ab 3 Übernachtungen")]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "bestellen Sie Ihren Weihnachtsbaum inkl. Lichterkette (gegen Gebühr) gleich dazu"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "mb-0" }, [
      _c("li", [
        _vm._v(
          "kostenfreie Stornierungsmöglichkeit bis 7 Tage vor Anreise (gültig für alle Neubuchungen mit Aufenthalt bis 31.03.2022)"
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }